import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagMM(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAMAAAAun0N9AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA8UExURfA6TD20PknHSv/LMP/OOv/MNUG7Qu00R//PP+suQUXCRvr6+fb29sTpxOnr3ZbYl2XEZvKvtvFfbv/dd4fJwsgAAAGmSURBVEjH1Y/rYqsgEIQXw0UFwSTv/64F9iJGpT31z+kHssMygwrjPeDP57UeNWrd6D56RJ8eoYSEVn8DWUHfAwxWo02eVchjPhR7jNayh9Jp7iAPdU2Fguyrfe6BaeHu1nibPtA/Hv340/yDZ32It7/6ADLBgzE4DKoyM9FHPtktUkH2B0rXe68fPaB7+s75dz8/9Fhyfuk6+vmQ86GfnwceZdlUPpuTLySytr7qLUBZSJMa0kLEmo+8TZtvpjdhfg/+9pFlOHrP8pkUKBPqLCKkUyfMlkcli6LXmHMheBlxlbNdBSvgHTPK/A94AT7LwC+wImqFXatBpS0d0uGYE2AvUHYJzJJ3F4Cq3rMRJR8PHhGgClYRIpRaw8bantm2QJOwtNRpE766LD59hqlaBeqKmkyqXhMvXZf58vmxfPca+QdO81c8Q3ge5c+J8SX6FeO/xl/P1+Xuv8I5qAMLq4+KDrdtaC8HjkujmgrshF2/XvQb4ES5X940sZy27oQLjuOU/uQAa4YKKjGVJk3XCNJuAolw2W7h5K7KOQqYbuBu5qf7+S+CeD9eFEf00gAAAABJRU5ErkJggg==",
    alt: "MM"
  }, props));
}